import styled from 'styled-components';

export const WrapperLoader = styled.div`
.loader-contenedor{
    position: fixed; /* Stay in place */
    z-index: 1; /* Sit on top */
    padding-top: 20%; /* Location of the box */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    overflow: auto; /* Enable scroll if needed */
    background-color: rgb(255,255,255); /* Fallback color */
    background-color: rgba(255, 255, 255, 0.6); /* Black w/ opacity */
}

img{
    margin-left: auto;
    margin-right: auto;
    margin-top: 44px;
    display: block;
    padding: 15px;
    width: 110px;
    border-radius: 20px;
    height: 110px;
}

`;


export default WrapperLoader;